import { Location } from 'react-router-dom';

const AUTH_RETURN_TO_KEY = 'chaizer_auth_return_to';
const AUTH_VERIFICATION_KEY = 'chaizer_auth_verification';

export type VerificationState = {
  username: string;
  data: Record<string, unknown>;
  type: 'mobile' | 'email';
};

export const isSafeInternalPath = (path: string | null | undefined): path is string => (
  typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//')
);

export const locationPath = (location: Pick<Location, 'pathname' | 'search' | 'hash'>) => (
  `${location.pathname}${location.search}${location.hash}`
);

export const saveAuthReturnTo = (path: string) => {
  if (isSafeInternalPath(path)) {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, path);
  }
};

export const getAuthReturnTo = (fallback: string) => {
  const storedPath = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
  return isSafeInternalPath(storedPath) ? storedPath : fallback;
};

export const clearAuthReturnTo = () => {
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
};

export const saveVerificationState = (state: VerificationState) => {
  sessionStorage.setItem(AUTH_VERIFICATION_KEY, JSON.stringify(state));
};

export const getVerificationState = (): VerificationState | null => {
  const value = sessionStorage.getItem(AUTH_VERIFICATION_KEY);
  if (!value) return null;

  try {
    const parsed = JSON.parse(value) as Partial<VerificationState>;
    if (
      typeof parsed.username === 'string'
      && parsed.data !== null
      && typeof parsed.data === 'object'
      && (parsed.type === 'mobile' || parsed.type === 'email')
    ) {
      return parsed as VerificationState;
    }
  } catch {
    return null;
  }

  return null;
};

export const clearVerificationState = () => {
  sessionStorage.removeItem(AUTH_VERIFICATION_KEY);
};
